export default __webpack_public_path__ + "static/ronald_cain-b306d37ae3981bf8f5d38355818afc56.png";